export interface SalesInvoicesStateModel {
  salesInvoices: SalesInvoice[];
  salesInvoicesForm: {
    model: SalesInvoicesForm;
    dirty: boolean;
    status: string;
    errors: any;
  };
  availableSSIs: AvailableSSI[];
  banks: Bank[],
  isNew: boolean,
  paymentForm: {
    model: PaymentForm;
    dirty: boolean;
    status: string;
    errors: any;
  };
  currentRendererId: string;
  currentSalesInvoice: string;
  currentChecksum: string;
}

export interface PaymentForm {
  paymentAmount: number;
  partialPaymentDate: string;
  paymentRef: string;
}

export interface CreatedBy {
  id: string;
  firstName: string;
  surname: string;
  email: string;
  role: string;
  timestamp: string;
}

export interface PartialPayment {
  paymentAmount: number;
  partialPaymentDate: string;
  paymentRef: string;
}

export interface SalesInvoice {
  _id: string;
  invoiceNumber: string;
  customerReference: string;
  invoiceFor: string;
  customerAddress: string;
  paymentTerms: string;
  deliveryTerms: string;
  ssiReference: string;
  salesInvoiceDate: string;
  expectedPaymentDate: string;
  status: string;
  customerId: string;
  partialPayments: PartialPayment[];
  bankId: string;
  salesShippingInstructionId: string;
  createdBy: CreatedBy;
  __v: number;
  createdAt: string;
  updatedAt: string;
  md5Checksum: string;
  customerName: string;
}

export interface SalesInvoicesForm {
  salesInvoiceDate: Date,
  expectedPaymentDate: Date,
  invoiceNumber: string,
  bankId: string,
  ssiReference: {
    _id: string,
    ssiReference: string,
  },
  invoiceFor: string,
  customerName: string,
  paymentTerms: string,
  deliveryTerms: string,
  customerId: string,
  customerAddress: string,
}

export interface AvailableSSI {
  _id: string;
  ssiReference: string;
}

export interface Bank {
  _id: string;
  bankName: string;
}

export const defaultAvailableSSI: AvailableSSI = {
  _id: null,
  ssiReference: null,
};

export const defaultBanks: Bank = {
  _id: null,
  bankName: null,
};

export const defaultSalesInvoicesForm: SalesInvoicesForm = {
  salesInvoiceDate: null,
  expectedPaymentDate: null,
  invoiceNumber: null,
  bankId: null,
  ssiReference: null,
  invoiceFor: null,
  customerName: null,
  paymentTerms: null,
  deliveryTerms: null,
  customerId: null,
  customerAddress: null,
};

export const defaultCreatedBy: CreatedBy = {
  id: null,
  firstName: null,
  surname: null,
  email: null,
  role: null,
  timestamp: null,
};

export const defaultPartialPayment: PartialPayment = {
  paymentAmount: null,
  partialPaymentDate: null,
  paymentRef: null,
};

export const defaultSalesInvoice: SalesInvoice = {
  _id: null,
  invoiceNumber: null,
  customerReference: null,
  invoiceFor: null,
  customerAddress: null,
  paymentTerms: null,
  deliveryTerms: null,
  ssiReference: null,
  salesInvoiceDate: null,
  expectedPaymentDate: null,
  status: null,
  customerId: null,
  partialPayments: [],
  bankId: null,
  salesShippingInstructionId: null,
  createdBy: defaultCreatedBy,
  __v: 0,
  createdAt: null,
  updatedAt: null,
  md5Checksum: null,
  customerName: null,
};

export const defaultSalesInvoicesState: SalesInvoicesStateModel = {
  salesInvoices: [],
  salesInvoicesForm: {
    model: defaultSalesInvoicesForm,
    dirty: false,
    status: null,
    errors: null,
  },
  availableSSIs: [],
  banks: [],
  isNew: false,
  paymentForm: {
    model: {
      paymentAmount: null,
      partialPaymentDate: null,
      paymentRef: null,
    },
    dirty: false,
    status: null,
    errors: null,
  },
  currentRendererId: null,
  currentSalesInvoice: null,
  currentChecksum: null,
};